import React from "react"
import PropTypes from "prop-types"
import { Select } from "@tencent/spaui"

const data = [
  {
    value: 'CONTRACT_METHOD_INTERVIEW',
    label: '面访',
  },
  {
    value: 'CONTRACT_METHOD_TELE_SALE',
    label: '电销',
  },
  {
    value: 'CONTRACT_METHOD_MEETING_SALE',
    label: '会销',
  },
  {
    value: 'CONTRACT_METHOD_NETWORK_SALE',
    label: '网销',
  },
];

class CreateOrderContractMethodSelect extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  }

  render() {
    const { value, onChange, onClear } = this.props
    // let data = _.map(enumMessages("ContractMethod"), (message) => {
    //   return {
    //     value: message.value,
    //     label: message.message,
    //   }
    // })
    // data = _.compact(data)

    return <Select clear={true} onClear={onClear} className="EducationSelect" data={data} value={value} onChange={onChange} />
  }
}

export default CreateOrderContractMethodSelect
